import React from 'react';
import { MoreOutlined } from '@ant-design/icons';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { ROUTE_PRIZES } from '../../shared/variables/routes';
import { Tooltip } from 'antd';

export default function Prizes({ showingPrizes }: { showingPrizes: Prizes.Prize[] }) {
  const { t } = useTranslation('profile');
  return (
    <div>
      <i>Ödüller</i>
      <p className="flex-vertical-center">
        {showingPrizes.map(item => (
          <img
            key={item.odul_baslik}
            className="mr-sm"
            style={{ maxWidth: '24px' }}
            src={item.odul_resim_url}
            alt={item.odul_baslik}
          />
        ))}
        <Link href={ROUTE_PRIZES}>
          <Tooltip title={t('prizes.allPrizes')}>
            <MoreOutlined rotate={90} />
          </Tooltip>
        </Link>
      </p>
    </div>
  );
}
